import {
  listOfflineQueuedOperations,
  updateOfflineOperation,
  type OfflineQueueRecord,
} from './offline-store';

interface ReviewedOfflinePayload extends Record<string, unknown> {
  offlineWriteMode?: unknown;
  reviewApprovedAt?: unknown;
  reviewApprovedBy?: unknown;
}

function nowIso(): string {
  return new Date().toISOString();
}

export async function retryOfflineOperation(id: string): Promise<void> {
  await updateOfflineOperation(id, { status: 'queued', lastError: null, nextRetryAt: null });
}

export async function approveOfflineOperationForSync(
  id: string,
  reviewerUserId: string | null = null
): Promise<void> {
  const current = (await listOfflineQueuedOperations(['conflict'])).find(
    (record) => record.id === id
  );
  if (!current) return;

  const payload = current.payload as ReviewedOfflinePayload;
  const patch: Partial<OfflineQueueRecord> = {
    status: 'queued',
    lastError: null,
    nextRetryAt: null,
    payload: {
      ...payload,
      offlineWriteMode: 'queue_review_approved',
      reviewApprovedAt: nowIso(),
      reviewApprovedBy: reviewerUserId,
    },
  };

  await updateOfflineOperation(id, patch);
}
